import { render, staticRenderFns } from "./TermsOfServiceView.vue?vue&type=template&id=02a25fce&scoped=true&"
import script from "./TermsOfServiceView.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceView.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfServiceView.vue?vue&type=style&index=0&id=02a25fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a25fce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
